import { Alert, Checkbox, Col, Collapse, DatePicker, Divider, Form, Input, Row } from 'antd'
import Templates from '../../../../api/Templates'
import Annual from '../../../../components/People/Member/Contract/Form/Table/Annual'
import Compassionate from '../../../../components/People/Member/Contract/Form/Table/Compassionate'
import Hospitalisation from '../../../../components/People/Member/Contract/Form/Table/Hospitalisation'
import Medical from '../../../../components/People/Member/Contract/Form/Table/Medical'
import Parental from '../../../../components/People/Member/Contract/Form/Table/Parental'
import Rates from '../../../../components/People/Member/Contract/Rates'
import CentersCascader from '../../../../elements/Cascader/CentersCascader'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import InfoText from '../../../../elements/InfoText'
import CountrySelect from '../../../../elements/Select/Country'
import Currency from '../../../../elements/Select/Currency'
import ContractTypeSelect from '../../../../elements/Select/Employee/ContractType'
import PayPeriod from '../../../../elements/Select/Employee/PayPeriod'
import RequisitionsSelect from '../../../../elements/Select/Employee/Requisitions'
import TypeSelect from '../../../../elements/Select/Employee/Type'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import _, { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'
import { dateVal, numVal, strVal } from '../../../../modules/Utils'
import React, { useEffect } from 'react'
import NoticePeriod from './NoticePeriod'

const { TextArea } = Input
const Panel = Collapse.Panel
const templateApi = new Templates()

function ContractForm(props) {
  const { getFieldDecorator, getFieldValue } = props.form
  let {
    contract,
    updateContract,
    updateContractRollover,
    updateContractMedicalOptions,
    employee,
    type,
  } = props

  const company = getFieldValue('company._id')

  const {
    fetch: fetchTemplate,
    fetching: fetchingTemplate,
    object: template,
    setObject: setTemplate,
  } = useFetchObject(
    () => templateApi.read(company.replace('members/', ''), 'employee'),
    false,
    [company],
    isEmpty(company),
  )

  useEffect(() => {
    if (type !== 'update') {
      console.log('in')
      contract.entitlements = template.entitlements
    }
  }, [company, template])

  return (
    <Form layout="horizontal">
      <Divider orientation="left">Contract Overview</Divider>
      <Row>
        <Col span={12}>
          <Form.Item label="Title" {...defaultFormItemLayout}>
            {getFieldDecorator('title', {
              initialValue: strVal(contract, 'title') || _.get(employee, 'role', ''),
              rules: rules.input,
            })(<Input placeholder="Title" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Employment Type" {...defaultFormItemLayout}>
            {getFieldDecorator('employmentType', {
              initialValue: strVal(contract, 'employmentType'),
              rules: rules.input,
            })(<TypeSelect />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label="Contract Type" {...defaultFormItemLayout}>
            {getFieldDecorator('contractType', {
              initialValue: strVal(contract, 'contractType'),
              rules: rules.input,
            })(<ContractTypeSelect />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Blanket" {...defaultFormItemLayout}>
            {getFieldDecorator('blanket', {
              initialValue: strVal(contract, 'blanket'),
              valuePropName: 'checked',
            })(<Checkbox />)}
          </Form.Item>
        </Col>
        {getFieldValue('contractType') !== 'casual' && (
          <Col span={12}>
            <Form.Item label="Requisition" {...defaultFormItemLayout}>
              {getFieldDecorator('requisition._id', {
                initialValue: strVal(contract, 'requisition._id'),
                // rules: rules.input,
              })(<RequisitionsSelect />)}
            </Form.Item>
          </Col>
        )}
        <Col span={12}>
          <Form.Item label="Company" {...defaultFormItemLayout}>
            {getFieldDecorator('company._id', {
              initialValue: strVal(contract, 'company._id') || _.get(employee, 'company._id', ''),
              rules: rules.input,
            })(<OrganisationsSelect />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Description" {...defaultFormItemLayout}>
            {getFieldDecorator('description', {
              initialValue: strVal(contract, 'description'),
            })(<TextArea placeholder="Description" rows={4} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Cost Center">
            {getFieldDecorator('center._id', {
              initialValue: get(contract, 'center._id'),
              rules: rules.select,
            })(
              <CentersCascader
                key={getFieldValue('company._id')}
                category={'Cost'}
                company={getFieldValue('company._id')}
              />,
            )}
          </Form.Item>
        </Col>
      </Row>
      <Divider style={{ marginTop: '70px' }} orientation="left">
        Key Terms
      </Divider>
      <Row>
        <Col span={12}>
          <Form.Item label="Start Date" {...defaultFormItemLayout}>
            {getFieldDecorator('date.start', {
              initialValue: dateVal(contract, 'date.start'),
              rules: rules.date,
            })(<DatePicker style={{ width: '100%' }} placeholder="Start Date" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="End Date" {...defaultFormItemLayout}>
            {getFieldDecorator('date.expiry', {
              initialValue: dateVal(contract, 'date.expiry'),
            })(<DatePicker style={{ width: '100%' }} placeholder="End Date" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Effective Date" {...defaultFormItemLayout}>
            {getFieldDecorator('date.effective', {
              initialValue: dateVal(contract, 'date.effective'),
              rules: rules.date,
            })(<DatePicker style={{ width: '100%' }} placeholder="Effective  Date" />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label="Probation End Date" {...defaultFormItemLayout}>
            {getFieldDecorator('date.probation', {
              initialValue: dateVal(contract, 'date.probation'),
              rules: rules.date,
            })(<DatePicker style={{ width: '100%' }} placeholder="Probation End Date" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row style={{ marginBottom: '70px' }}>
        {getFieldValue('company._id') && (
          <NoticePeriod
            contract={contract}
            updateContract={updateContract}
            company={getFieldValue('company._id')}
          />
        )}
      </Row>
      <Divider style={{ marginTop: '70px' }} orientation="left">
        Pay Details
      </Divider>
      <Row>
        <Col span={12}>
          <Form.Item label="Pay Period" {...defaultFormItemLayout}>
            {getFieldDecorator('pay.period', {
              initialValue: strVal(contract, 'pay.period'),
              rules: rules.select,
            })(<PayPeriod />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Pay Currency" {...defaultFormItemLayout}>
            {getFieldDecorator('pay.currency', {
              initialValue: strVal(contract, 'pay.currency'),
              rules: rules.select,
            })(<Currency />)}
          </Form.Item>
        </Col>
      </Row>

      {getFieldValue('company._id') && (
        <Rates
          updateContract={updateContract}
          employee={employee}
          type={type}
          contract={contract}
          company={getFieldValue('company._id')}
        />
      )}

      <Divider style={{ marginTop: '70px' }} orientation="left">
        Entitlements
      </Divider>

      {getFieldValue('contractType') === 'casual' && (
        <Alert
          message="Employee Entitlements are not available for Casual type of contract"
          type="warning"
        />
      )}

      {getFieldValue('contractType') !== 'casual' && (
        <Collapse accordion defaultActiveKey={['1']} bordered={false}>
          <Panel header="ANNUAL LEAVE" key="1">
            <Annual
              data={_.get(contract, 'entitlements.annual', [])}
              rollover={numVal(contract, 'entitlements.rollover.annual')}
              updateContract={updateContract}
              updateContractRollover={updateContractRollover}
              type={type}
            />
          </Panel>
          <Panel header="COMPASSIONATE" key="2">
            <Compassionate
              data={_.get(contract, 'entitlements.compassionate')}
              rollover={numVal(contract, 'entitlements.rollover.compassionate')}
              updateContract={updateContract}
              updateContractRollover={updateContractRollover}
              type={type}
            />
          </Panel>
          <Panel header="HOSPITALISATION" key="3">
            <Hospitalisation
              data={_.get(contract, 'entitlements.hospitalisation')}
              rollover={numVal(contract, 'entitlements.rollover.hospitalisation')}
              updateContract={updateContract}
              updateContractRollover={updateContractRollover}
              type={type}
            />
          </Panel>
          <Panel header="MEDICAL" key="4">
            <Medical
              data={_.get(contract, 'entitlements.medical')}
              rollover={numVal(contract, 'entitlements.rollover.medical')}
              updateContract={updateContract}
              medicalOptions={_.get(contract, 'entitlements.medicalOptions')}
              updateContractMedicalOptions={updateContractMedicalOptions}
              updateContractRollover={updateContractRollover}
              type={type}
            />
          </Panel>
          <Panel header="PARENTAL" key="5">
            <Parental
              data={_.get(contract, 'entitlements.parental')}
              rollover={numVal(contract, 'entitlements.rollover.parental')}
              updateContract={updateContract}
              updateContractRollover={updateContractRollover}
              type={type}
            />
          </Panel>
        </Collapse>
      )}

      <Divider style={{ marginTop: '70px' }} orientation="left">
        Communication
      </Divider>

      <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
        <h3 style={{ color: '#1890ff' }}>NOTICE ADDRESS</h3>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Country" {...defaultFormItemLayout}>
            {getFieldDecorator('employee.address.country', {
              initialValue: strVal(contract, 'employee.address.country'),
              rules: [
                {
                  required: true,
                  message: "Country can't be empty ",
                },
              ],
            })(<CountrySelect />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Postcode" {...defaultFormItemLayout}>
            {getFieldDecorator('employee.address.postcode', {
              initialValue: strVal(contract, 'employee.address.postcode'),
              rules: [
                {
                  required: true,
                  message: "Postcode can't be empty ",
                },
              ],
            })(<Input placeholder="Postcode" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item label="Street" {...fullWidthFormItemLayout}>
            {getFieldDecorator('employee.address.street', {
              initialValue: strVal(contract, 'employee.address.street'),
              rules: [
                {
                  required: true,
                  message: "Street can't be empty ",
                },
              ],
            })(<Input placeholder="Street" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item label="Building" {...fullWidthFormItemLayout}>
            {getFieldDecorator('employee.address.address', {
              initialValue: strVal(contract, 'employee.address.address'),
            })(<Input placeholder="Building" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Town / Suburb" {...defaultFormItemLayout}>
            {getFieldDecorator('employee.address.city', {
              initialValue: strVal(contract, 'employee.address.city'),
              rules: [
                {
                  required: true,
                  message: "Town / Suburb can't be empty ",
                },
              ],
            })(<Input placeholder="Town / Suburb" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="City / State" {...defaultFormItemLayout}>
            {getFieldDecorator('employee.address.state', {
              initialValue: strVal(contract, 'employee.address.state'),
              rules: [
                {
                  required: true,
                  message: '"City / State can\'t be empty ',
                },
              ],
            })(<Input placeholder="City / State" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
        <h3 style={{ color: '#1890ff' }}>CONTACT DETAILS</h3>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Phone" {...defaultFormItemLayout}>
            {getFieldDecorator('employee.phone.label', {
              initialValue: strVal(contract, 'employee.phone.label'),
              rules: [
                {
                  required: true,
                  message: "Phone can't be empty ",
                },
              ],
            })(<Input placeholder="Phone" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Fax" {...defaultFormItemLayout}>
            {getFieldDecorator('employee.fax.label', {
              initialValue: strVal(contract, 'employee.fax.label'),
            })(<Input placeholder="Fax" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Mobile" {...defaultFormItemLayout}>
            {getFieldDecorator('employee.mobile.label', {
              initialValue: strVal(contract, 'employee.mobile.label'),
            })(<Input placeholder="Mobile" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Email" {...defaultFormItemLayout}>
            {getFieldDecorator('employee.email.label', {
              initialValue: strVal(contract, 'employee.email.label'),
              rules: [
                {
                  required: true,
                  message: "Email can't be empty ",
                },
              ],
            })(<Input placeholder="Email" />)}
          </Form.Item>
        </Col>
      </Row>
      {type !== 'update' && (
        <InfoText text={'Contact details are pre-loaded from employee default contacts'} />
      )}
    </Form>
  )
}

export default Form.create()(ContractForm)
